import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaConciergeBell, FaEnvelope } from "react-icons/fa";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="notfound-page">
      <div className="notfound-bg-num">404</div>

      <div className="notfound-content">
        <div className="notfound-brand">NEXUS SOLUTIONS</div>
        <h1 className="notfound-title">Cette page n'existe pas</h1>
        <p className="notfound-text">
          Elle a peut-etre ete deplacee ou l'adresse est incorrecte.<br />
          Voici ou vous pouvez aller :
        </p>

        <div className="notfound-links">
          <Link to="/" className="notfound-link">
            <FaHome size={18} />
            <span>Accueil</span>
          </Link>
          <Link to="/services" className="notfound-link">
            <FaConciergeBell size={18} />
            <span>Nos services</span>
          </Link>
          <Link to="/contact" className="notfound-link">
            <FaEnvelope size={18} />
            <span>Nous contacter</span>
          </Link>
          {/* <a
            href="https://wa.me/2250142578758"
            target="_blank"
            rel="noreferrer"
            className="notfound-link notfound-link--wa"
          >
            <FaWhatsapp size={18} />
            <span>WhatsApp</span>
          </a> */}
        </div>

        <Link to="/devis" className="notfound-devis-btn">
          Ou demarrez un devis gratuit &rarr;
        </Link>
      </div>
    </div>
  );
}
